import * as React from "react"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `#35C567`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
      }}
    ></div>
  </header>
)

export default Header
